import { ReactComponent as UnitedKingdomFlagIcon } from '../../assets/united-kingdom-flag.svg';
import { ReactComponent as SerbianFlagIcon } from '../../assets/serbian-flag.svg';
import { ReactComponent as PortugalFlagIcon } from '../../assets/portugal-flag.svg';
import { ReactComponent as VietnamFlagIcon } from '../../assets/vietnam-flag.svg';
import { LanguageCodeDisplayEnum, LanguageCodeEnum } from '../enums/common.enum';
import React from 'react';

export const languageMeta: Record<LanguageCodeEnum, { label: string; shortLabel: string; Flag: React.FC<React.SVGProps<SVGSVGElement>> }> = {
  [LanguageCodeEnum.ENG]: {
    label: 'English',
    shortLabel: LanguageCodeDisplayEnum.ENG,
    Flag: UnitedKingdomFlagIcon
  },
  [LanguageCodeEnum.SRB]: {
    label: 'Serbian',
    shortLabel: LanguageCodeDisplayEnum.SRB,
    Flag: SerbianFlagIcon
  },
  [LanguageCodeEnum.PRT]: {
    label: 'Portuguese',
    shortLabel: LanguageCodeDisplayEnum.PRT,
    Flag: PortugalFlagIcon
  },
  [LanguageCodeEnum.VNM]: {
    label: 'Vietnamese',
    shortLabel: LanguageCodeDisplayEnum.VNM,
    Flag: VietnamFlagIcon
  }
};
